export default __webpack_public_path__ + "static/media/insta20.f7def21f.webp";